import React, { Component } from 'react';
import { IntlProvider, addLocaleData } from "react-intl";
import frLocaleData from "react-intl/locale-data/fr";
import enLocaleData from "react-intl/locale-data/en";
import translations from "./i18n/locales"
import App from "./App";

addLocaleData(frLocaleData);
addLocaleData(enLocaleData);

class AppWrapper extends Component {
  constructor(props) {
    super(props)
    const localeFromUrl = window.location.search.replace("?locale=","")
    const savedLang = window.localStorage ? window.localStorage.getItem("onehour-lang") : null
    const initialLang = localeFromUrl || savedLang || "fr"
    this.state = {
      lang: initialLang === "en" ? "en" : "fr"
    }
  }

  toggleLang = (lang) => {
    if (window.localStorage) {
      window.localStorage.setItem("onehour-lang", lang)
    }
    this.setState({
      lang: lang
    })
  }
  render() {
    const locale = this.state.lang
    const messages = translations[locale];
    return (
      <IntlProvider locale={locale} key={locale} messages={messages}>
        <App
          handleLang={(lang) => this.toggleLang(lang)}
          lang={this.state.lang}
        />
      </IntlProvider>
    );
  }
}
export default AppWrapper



// WEBPACK FOOTER //
// ./src/AppWrapper.js